// extracted by mini-css-extract-plugin
export var table = "table-module--table--911dd";
export var tableWrapper = "table-module--table-wrapper--ab2ed";
export var td = "table-module--td--8dafd";
export var th = "table-module--th--4a8d2";
export var thead = "table-module--thead--33822";
export var tr = "table-module--tr--c271a";